import React from "react";
import { HomeSearchResultGridCellTemplate } from "themes/application/home/components";

function HomeSearchResultGridCell(props) {
    return <HomeSearchResultGridCellTemplate {...props} />;
}

export default HomeSearchResultGridCell;
